const slideshow = {
    getlist: 'slideshow/getlist-by-admin',
    add: 'slideshow/add',
    update: 'slideshow/update',
    remove: 'slideshow/remove',
    get: 'slideshow/get',
}
export default slideshow
